import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import StudentRevisionPlansComponent from './OverviewWidgetComponents/StudentRevisionPlansComponent';
import { getConfigObject } from '../../util/config';

export const StudentWidget = (props) => {
  const {
    reports: { courseAbstract },
    getLaunchUrl,
  } = props;
  const { student: isStudent = false } = courseAbstract || {};
  if (!isStudent || !getConfigObject().DASHBOARD_ENABLED_REVISION_PLAN_WIDGET) {
    return null;
  }

  return <StudentRevisionPlansComponent getLaunchUrl={getLaunchUrl} />;
};

StudentWidget.propTypes = {
  reports: PropTypes.object,
  getLaunchUrl: PropTypes.func,
};

const mapStateToProps = (state) => ({
  reports: state.reports,
  loading:
    !state.reports.courseAbstract ||
    state.reports.courseAbstract.loading ||
    !state.reports.revisionPlanWidget ||
    state.reports.revisionPlanWidget.loading,
});

export default connect(mapStateToProps)(StudentWidget);
